// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content[data-v-911dbda0] {

    display: flex;

    flex-direction: column;

    align-items: center;

    --tw-bg-opacity: 1;

    background-color: rgb(0 154 250 / var(--tw-bg-opacity))
}
.content .new-mortgage-jumbo__image[data-v-911dbda0] {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    max-width: 12.25rem;

    align-items: center;

    justify-content: center
}
@media (min-width: 996px) {
.content .new-mortgage-jumbo__image[data-v-911dbda0] {

        max-width: none
}
}
@media (min-width: 1320px) {
.content .new-mortgage-jumbo__image[data-v-911dbda0] {

        width: 80%
}
}
.content .new-mortgage-jumbo__content[data-v-911dbda0] {

    display: flex;

    max-width: 24rem;

    flex-direction: column;

    row-gap: 1.5rem;

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity))
}
@media (min-width: 996px) {
.content .new-mortgage-jumbo__content[data-v-911dbda0] {

        max-width: 48rem;

        padding-left: 4rem
}
}
.content .new-mortgage-jumbo__content h2[data-v-911dbda0] {

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700
}
.content .new-mortgage-jumbo__content ul[data-v-911dbda0] {

    list-style-type: none
}
@media (min-width: 996px) {
.content .new-mortgage-jumbo__content ul[data-v-911dbda0] {

        list-style-type: initial
}
}
.content .new-mortgage-jumbo__content ul li[data-v-911dbda0] {

    margin-top: 1rem;

    margin-bottom: 1rem;

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400
}
@media (min-width: 996px) {
.content .new-mortgage-jumbo__content__button[data-v-911dbda0] {

        align-self: flex-start
}
}
.content .new-mortgage-jumbo[data-v-911dbda0] .jumbo__content {

    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/NewMortgageJumbo.vue"],"names":[],"mappings":";AA8BA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAKA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA,eAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,gBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA;AAAA;AAIA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAKA;AAAA;;QAAA;AAAA;AAAA;AAMA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"content\">\n    <!-- New mortgage jumbo -->\n    <Jumbo class=\"new-mortgage-jumbo\">\n      <template #before>\n        <div class=\"new-mortgage-jumbo__image\">\n          <ImageComponent src=\"img/web/new-mortgage-picto.webp\" alt=\"Imagen comprar vivienda\" width=\"606\"></ImageComponent>\n        </div>\n      </template>\n\n      <template #after>\n        <div class=\"new-mortgage-jumbo__content\">\n          <h2>Quiero comprar una vivienda</h2>\n          <ul>\n            <li>Te daremos una visión realista de tu capacidad de compra.</li>\n            <li>Te daremos varias opciones entre las que elegir, con condiciones que no te ofrecerían como particular.</li>\n            <li>Te acompañaremos en todo el proceso, desde la negociación con las entidades, hasta la firma de tu hipoteca.</li>\n            <li>Todo ello lo haremos gratis.</li>\n          </ul>\n          <Button tag=\"a\" :href=\"route('funnel.new')\" class=\"new-mortgage-jumbo__content__button\">\n            Simular mi hipoteca\n          </Button>\n        </div>\n      </template>\n    </Jumbo>\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.content {\n  @apply flex flex-col items-center bg-support-dark;\n\n  .new-mortgage {\n    &-jumbo {\n      &__image {\n        @apply flex justify-center items-center mx-auto xl:w-4/5 max-w-[12.25rem] lg:max-w-none;\n      }\n\n      &__content {\n        @apply flex flex-col gap-y-xxs lg:pl-xl text-neutral-white max-w-sm lg:max-w-3xl;\n\n        h2 {\n          @apply style-subtitle-bold;\n        }\n\n        ul {\n          @apply list-none lg:list-[initial];\n\n          li {\n            @apply style-body my-xxxs;\n          }\n        }\n\n        &__button {\n          @apply lg:self-start;\n        }\n      }\n\n      /deep/ .jumbo {\n        &__content {\n          @apply justify-center;\n        }\n      }\n    }\n  }\n}\n</style>\n\n<script>\nimport Jumbo from '@/lego/components/layout/Jumbo.vue';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport ImageComponent from '@/lego/components/images/Image.vue';\n\nexport default {\n  components: {\n    Jumbo,\n    Button,\n    ImageComponent,\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
